import { BaseFormula } from "../../BaseFormula";
import { CalculationResult } from "../../CalculationResult";
import { ChangeType } from "../../ChangeType";
import { CostData } from "../../CostData";

export class Formula_PercentageByMax extends BaseFormula
{
    evaluate(data: CostData[], value: CostData, change: ChangeType, parameters: { threshold: number }, show_new_cost: boolean): CalculationResult
    {
        let err = this.checkLength(data, 2, show_new_cost);
        if (err)
            return err;

        let max = Math.max(...data.map(d => d.amount));
        let percent = (value.amount - max) / max * 100;

        err = this.checkChnage(change, percent, { max, percent });
        if (err)
            return err;

        return {
            value: Math.abs(percent) >= parameters.threshold,
            values: { max, percent }
        };
    }
} 